import { gql } from "@apollo/client";

export const GET_FILE_DOWNLOAD_URL = gql(`
  query GetPresignedFileDownloadUrl($key: String!) {
    getPresignedFileDownloadUrl(key: $key)
  }
`);

export const GET_FILES_DOWNLOAD_URLS = gql(`
  query GetSignedDownloadUrlsFromKeys($args: FilesInput!) {
    getSignedDownloadUrlsFromKeys(args: $args) {
      files{
        id
        url
        key
        fileType
        createdAt
        read
      }
    }
  }
`);

export const GET_FILE_UPLOAD_URL = gql(`
  query Query($fileName: String!) {
    getPresignedFileUploadUrl(fileName: $fileName)
  }
`);

export const GetFilesOfOrderDocument = gql(`
  query GetFilesOfOrder($where: FileWhereInput) {
    getFilesOfOrder(where: $where) {
      chat {
        id
        orderId
        userGroupId
      }
      fileType
      key
      keyCompressed
      userId
      id
      read
      createdAt
    }
  }
`);

export const CreateFileDocument = gql(`
  mutation CreateFile($args: FileCreateInput!) {
    createFile(args: $args) {
      key
      keyCompressed
      orderId
      userId
      fileType
      id
      chatId
    }
  }
`);

export const DeleteFileDocument = gql(`
  mutation DeleteFile($key: String!, $where: FileWhereUniqueInput!) {
    deleteFile(key: $key, where: $where) {
      key
    }
  }
`);

export const DeleteS3FileDocument = gql(`
  mutation DeleteS3File($key: String!) {
    deleteS3File(key: $key) 
  }
`);

export const getPresignedPost = gql(`
  query getPresignedFileUploadUrl($fileName: String!) {
    getPresignedFileUploadUrl(fileName: $fileName)
  }
`);

export const GetOrderHelpFilesDocument = gql(`
  query GetOrderHelpFiles($orderId: String!) {
    getOrderHelpFiles(orderId: $orderId) {
      id
      key
      fileType
    }
  }
`);

export const CreateOrderHelpFileDocument = gql(`
  mutation CreateOrderHelpFile($orderId: String!, $key: String!) {
    createOrderHelpFile(orderId: $orderId, key: $key) {
      id
      key
      fileType
    }
  }
`);

export const DeleteOrderHelpFileDocument = gql(`
  mutation DeleteOrderHelpFile($orderId: String!, $fileId: String!) {
    deleteOrderHelpFile(orderId: $orderId, fileId: $fileId)
  }
`);
